export const AGREEMENTS_TABLE_NAME = 'TraceAgreementsTable';

/** Task pane element id; must match reporting target filter field specs and the Get-Agreements payload builder. */
export const AGREEMENTS_FACILITY_CODES_ELEMENT_ID = 'filter-facility-codes';

/**
 * `filter-record-type` value for “All types” (omit `agreementType` on Get-Agreements). Must match
 * `agreements.definition` recordTypeFilter options and `readAgreementsTaskPaneFilterFromDom`.
 */
export const AGREEMENTS_RECORD_TYPE_ALL_VALUE = 'all';

export const agreementStatusLabels: Record<number, string> = {
    0: 'Draft',
    1: 'Deleted',
    2: 'Pending Approval',
    3: 'Active',
    4: 'Under Amendment',
    5: 'Inactive',
};

/** Matches `OperationType` / `OPERATION_TYPE_LABELS` in isb-shared `bundles.models` — Get-Agreements `agreementType`. */
export const agreementTypeLabels: Record<number, string> = {
    0: 'Inbound',
    1: 'Outbound',
    2: 'Internal',
};

export const statusNameToCode: Record<string, number> = {
    draft: 0,
    deleted: 1,
    'pending approval': 2,
    active: 3,
    'under amendment': 4,
    inactive: 5,
};
